import type {
  EntityTemplateDetail,
  EntityTemplateCreateVariables,
  EntityTemplateUpdateVariables,
  EntityTemplateEntity,
} from "./entity-template.type";
import type { UseGetOptions, UseUpdateOptions } from "@/hooks/queries";

import { useCreate, useGet, useUpdate } from "@/hooks/queries";

export const useGetEntityTemplate = (
  entityTemplateId?: string | number,
  options?: UseGetOptions<EntityTemplateDetail>
) => {
  const { data, ...queryResult } = useGet<EntityTemplateDetail>(
    "entityTemplates",
    entityTemplateId,
    options
  );

  return {
    template: data,
    schema: data?.content ?? {},
    ...queryResult,
  };
};

export const useCreateEntityTemplate = () => {
  return useCreate<EntityTemplateEntity, EntityTemplateCreateVariables>(
    "entityTemplates"
  );
};

export const useUpdateEntityTemplate = (
  templateId: number,
  options?: UseUpdateOptions
) => {
  return useUpdate<EntityTemplateEntity, EntityTemplateUpdateVariables>(
    "entityTemplates",
    templateId,
    options
  );
};
